import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import {
  LayoutDashboard, FilePen, ShieldCheck, Code2, Cpu, ChevronRight, Layers, PenSquare
} from "lucide-react";

const navItems = [
  { to: "/", icon: LayoutDashboard, label: "Dashboard" },
  { to: "/sign", icon: FilePen, label: "Assinar Documento", exact: true },
  { to: "/sign/visible", icon: PenSquare, label: "Assinatura Visível" },
  { to: "/sign/batch", icon: Layers, label: "Assinatura em Lote" },
  { to: "/verify", icon: ShieldCheck, label: "Verificar Assinatura" },
  { to: "/integrar", icon: Code2, label: "Integração SDK" },
  { to: "/agente", icon: Cpu, label: "Agente Local" },
];

export default function Sidebar() {
  const location = useLocation();

  return (
    <aside className="w-64 bg-white border-r border-black/5 flex flex-col h-full shadow-sm flex-shrink-0">
      {/* Logo */}
      <div className="p-6 border-b border-black/5">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 bg-[#163A24] rounded-lg flex items-center justify-center">
            <ShieldCheck size={18} className="text-white" />
          </div>
          <div>
            <p className="font-bold text-[#163A24] text-sm leading-tight" style={{ fontFamily: "Outfit, sans-serif" }}>
              Assinador
            </p>
            <p className="text-[10px] text-gray-400 uppercase tracking-widest">Digital ICP-Brasil</p>
          </div>
        </div>
      </div>

      {/* Nav */}
      <nav className="flex-1 p-4 space-y-1" data-testid="sidebar-nav">
        {navItems.map(({ to, icon: Icon, label, exact }) => {
          const isActive = exact
            ? location.pathname === to
            : (to === "/" ? location.pathname === "/" : location.pathname.startsWith(to));
          return (
            <NavLink
              key={to}
              to={to}
              data-testid={`nav-${label.toLowerCase().replace(/\s+/g, "-")}`}
              className={`flex items-center gap-3 px-3 py-2.5 rounded-md text-sm font-medium transition-all duration-200 group ${
                isActive
                  ? "bg-[#163A24] text-white shadow-sm"
                  : "text-gray-600 hover:bg-gray-50 hover:text-[#163A24]"
              }`}
            >
              <Icon size={16} className={isActive ? "text-[#8FBC8F]" : "text-gray-400 group-hover:text-[#163A24]"} />
              <span className="flex-1">{label}</span>
              {isActive && <ChevronRight size={14} className="text-[#8FBC8F]" />}
            </NavLink>
          );
        })}
      </nav>

      {/* Footer */}
      <div className="p-4 border-t border-black/5">
        <div className="bg-[#FAF9F6] rounded-md p-3">
          <p className="text-[10px] text-gray-400 uppercase tracking-widest mb-1">Versão</p>
          <p className="text-xs font-semibold text-gray-600">Assinador Digital v1.0</p>
          <p className="text-[10px] text-gray-400 mt-0.5">ICP-Brasil | CAdES · PAdES · XAdES</p>
        </div>
      </div>
    </aside>
  );
}
